<script>
import { options } from "../config";

import { loading } from "../loader";
import { PostContact } from "../Services/form0";
import { message_ } from "../Services/messages";




    let data= {}

const save = ()=>{
    let d = {
        profile:options.profile,
        form:"covid/guest",
        data:data
    }

    loading.set(true)
    PostContact(d,null,(result)=>{
        loading.set(false)
        console.log(result)
    },(error=>{
        message_.set("Broken result")
        loading.set(false)
    }))

}
</script>

<div class="section_wrapper">
    <div class="s s100 box ">
        <div class="content_area" >
            <h1>Covid Registration for base2Services office</h1>
            <label for="name">Name</label>
            <input id="name" type="text" bind:value={data.name}>

            <label for="phone">Contact Number</label>
            <input id="phone" type="text" bind:value={data.phone}>


            <a class="linkbox green" on:click={()=>save()}>Submit</a>
        </div>
    </div>
</div>
